import {$isElementNode, NodeKey, PointType, RangeSelection} from 'lexical';

import {isNil} from 'ramda';

import {TextEditorSelection} from '../../../types/TextEditorApi';
import {$collectEditorNodeRanges, EditorNodeRange} from './collectEditorNodeRanges';

const $pointToIndex = (point: PointType, rangeByKey: Map<NodeKey, EditorNodeRange>) => {
  const node = point.getNode();
  const range = rangeByKey.get(node.getKey());

  if (isNil(range)) {
    return null;
  }

  if (point.type === 'text') {
    return range.start + point.offset;
  }

  if (!$isElementNode(node)) {
    return null;
  }

  const child = node.getChildAtIndex(point.offset);

  return isNil(child) ? range.end : (rangeByKey.get(child.getKey())?.start ?? null);
};

export function $getEditorIndexRange(selection: RangeSelection): TextEditorSelection | null {
  const {rangeByKey} = $collectEditorNodeRanges();
  const anchor = $pointToIndex(selection.anchor, rangeByKey);
  const focus = $pointToIndex(selection.focus, rangeByKey);

  if (isNil(anchor) || isNil(focus)) {
    return null;
  }

  return {index: Math.min(anchor, focus), length: Math.abs(anchor - focus)};
}
